import React, { useEffect } from 'react';
import { useRegistration } from '../../context/RegistrationContext';

const Timer = () => {
  const { state, dispatch, actionTypes } = useRegistration();
  const { timeLeft } = state;

  useEffect(() => {
    // Spustenie časovača, keď je aktívna rezervácia
    if (state.rezervacia && timeLeft > 0) {
      const timer = setInterval(() => {
        dispatch({ type: actionTypes.UPDATE_TIME_LEFT, payload: timeLeft - 1 });
      }, 1000);
      
      return () => clearInterval(timer);
    }
  }, [state.rezervacia, timeLeft, dispatch, actionTypes]);

  // Formátovanie času
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  // Určenie triedy podľa zostávajúceho času
  const getTimerClass = () => {
    if (timeLeft < 15) return 'text-accent font-bold animate-pulse';
    if (timeLeft < 30) return 'text-accent';
    return 'text-primary';
  };

  return (
    <div className="flex items-center justify-center my-4">
      <div className="text-center">
        <h3 className="text-sm font-medium mb-1">Čas na dokončenie registrácie:</h3>
        <div className={`text-xl font-bold ${getTimerClass()}`}>
          {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </div>
        <p className="text-xs mt-1 text-gray-500">
          Po vypršaní času bude rezervácia zrušená.
        </p>
      </div>
    </div>
  );
};

export default Timer;
